const t = {
  name: "Battery1",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 15V9H5V15H7Z" fill="currentColor"/>
<path d="M1 8C1 6.34772 2.34772 5 4 5H16C17.6523 5 19 6.34772 19 8V16C19 17.6523 17.6523 19 16 19H4C2.34772 19 1 17.6523 1 16V8ZM4 7C3.45228 7 3 7.45228 3 8V16C3 16.5477 3.45228 17 4 17H16C16.5477 17 17 16.5477 17 16V8C17 7.45228 16.5477 7 16 7H4Z" fill="currentColor"/>
<path d="M23 15V9H21V15H23Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Battery1
};
